import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { ExpandMore } from "@mui/icons-material";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import BackButton from "../../components/BackButton/BackButton";
import { getInvoices } from "../../redux/actions/getInvoiceAction";
import { useSelector, useDispatch } from "react-redux";
import { Route, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";

import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
const GetInvoiceDetails = () => {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const classes = useStyles();
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [invoiceStatus, setInvoiceStatus] = useState(false);
	const [invoiceResArray, setInvoiceResArray] = useState([]);

	const getInvoiceRes = useSelector(({ getInvoice }) => getInvoice);

	const location = useLocation();
	var memberID = location.search.split("=")[1];

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getInvoiceFunc = (memberID) => {
		if (getInvoiceRes.success == true) {
			getInvoiceRes.data.invoiceList.forEach((item) => {
				if (item.systemInvoiceId == memberID) {
					// console.log(item);
					setInvoiceResArray(item);
				}
			});
		}
		if (getInvoiceRes.success == false) {
			setInvoiceResArray(getInvoiceRes.data);
		}
	};

	useEffect(() => {
		if (memberID != "") {
			getInvoiceFunc(memberID);
		}
	}, [getInvoiceRes.success]);

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: "",
						paddingTop: "0.5rem",
						paddingBottom: "1rem"
					}}
				>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">Invoice Details</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer
										component={Paper}
										style={{
											marginBottom: "30px"
										}}
									>
										{getInvoiceRes.data.invoiceList &&
										getInvoiceRes.data.invoiceList ? (
											<>
												<Table
													className={classes.table}
													aria-label="a dense table"
													style={{ whiteSpace: "nowrap" }}
												>
													<TableHead>
														<TableRow className="tableHeaderColor">
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Tracking Id{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Invoice No
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Order Id
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Order Description
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Invoice Amount{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Date of Invoice
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																{" "}
																Invoice Status
															</TableCell>
														</TableRow>
													</TableHead>
													{invoiceResArray && (
														<TableBody>
															{invoiceResArray &&
																[].concat(invoiceResArray).map((row, index) => (
																	<TableRow key={index}>
																		<TableCell align="center">
																			{row.trackingid ? row.trackingid : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.systemInvoiceId
																				? row.systemInvoiceId
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.orderId ? row.orderId : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.orderDescription
																				? row.orderDescription
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.amount ? row.amount : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.createdDate ? row.createdDate : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.invoiceStatus
																				? row.invoiceStatus
																				: "-"}
																		</TableCell>
																	</TableRow>
																))}
														</TableBody>
													)}
												</Table>
											</>
										) : (
											""
										)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer component={Paper} style={{ marginBottom: "20px" }}>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Invoice Details
          </Typography>

          <Table>
            <TableHead>
              <TableRow style={{ background: "#00b9f5" }}>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Tracking Id{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Invoice No{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Order Id
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Order Description
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Invoice Amount{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Date of Invoice
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  Invoice Status
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">9180</TableCell>
                <TableCell align="center">AB_1189810334</TableCell>
                <TableCell align="center">
                  Duplicate order for AB_1189810332
                </TableCell>
                <TableCell align="center">12.00</TableCell>
                <TableCell align="center">2022-07-04</TableCell>
                <TableCell align="center">regenerated</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Customer's Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer
										component={Paper}
										style={{
											marginBottom: "30px"
										}}
									>
										{invoiceResArray && invoiceResArray ? (
											<>
												<Table
													className={classes.table}
													aria-label="a dense table"
													style={{ whiteSpace: "nowrap" }}
												>
													<TableHead>
														<TableRow className="tableHeaderColor">
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Customers's Name{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Customer's Email Id{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Tel No
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																City
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Street{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																State
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Country
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Pin Code
															</TableCell>
														</TableRow>
													</TableHead>
													{invoiceResArray && (
														<TableBody>
															{invoiceResArray &&
																[].concat(invoiceResArray).map((row, index) => (
																	<TableRow key={index}>
																		<TableCell align="center">
																			{row.raiseby ? row.raiseby : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.customerDetails.customeremail
																				? row.customerDetails.customeremail
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.customerDetails.customermobileno
																				? row.customerDetails.customermobileno
																				: "-"}
																		</TableCell>
																		<TableCell align="center">-</TableCell>
																		<TableCell align="center">-</TableCell>
																		<TableCell align="center">-</TableCell>
																		<TableCell align="center">-</TableCell>
																		<TableCell align="center">-</TableCell>
																	</TableRow>
																))}
														</TableBody>
													)}
												</Table>
											</>
										) : (
											""
										)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{invoiceResArray.productlist && invoiceResArray.productlist ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography className="themeText">
											Product List Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<TableContainer
											component={Paper}
											style={{
												marginBottom: "30px"
											}}
										>
											{invoiceResArray && invoiceResArray ? (
												<>
													<Table
														className={classes.table}
														aria-label="a dense table"
														style={{ whiteSpace: "nowrap" }}
													>
														<TableHead>
															<TableRow className="tableHeaderColor">
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Product Description
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Product Unit
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Product Amount
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Quantity
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Tax(%)
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Sub Total
																</TableCell>
															</TableRow>
														</TableHead>
														{invoiceResArray && (
															<TableBody>
																{invoiceResArray &&
																	[]
																		.concat(invoiceResArray)
																		.map((row, index) => (
																			<TableRow key={index}>
																				<TableCell align="center">
																					{row.productlist.productDescription
																						? row.productlist.productDescription
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.productlist.productUnit
																						? row.productlist.productUnit
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.productlist.productAmount
																						? row.productlist.productAmount
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.productlist.quantity
																						? row.productlist.quantity
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.productlist.tax
																						? row.productlist.tax
																						: "-"}
																				</TableCell>
																				<TableCell align="center">-</TableCell>
																			</TableRow>
																		))}
															</TableBody>
														)}
													</Table>
												</>
											) : (
												""
											)}
										</TableContainer>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}
					</Box>
				</div>
				{/* <TableContainer component={Paper}>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Customer's Details
          </Typography>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Customers's Name{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Customer's Email Id{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Tel No
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  City
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Street{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  State
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Country
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Pin Code
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell align="center">Amey</TableCell>
                <TableCell align="center">amey.dalvi@paymentz.com </TableCell>
                <TableCell align="center">8149389795</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer> */}
			</Layout>
		</>
	);
};

export default GetInvoiceDetails;
